import { Component } from 'react';
import { Card, Placeholder, ListGroup, Button, Container, Row, Col } from "react-bootstrap";
import { DateTime } from 'luxon';
import GameData from "../mobx/GameData";

import "./GameCard.scss";
import ApplicationState from "../mobx/ApplicationState";

export default class GameCard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            game: props.game,
            isMini: !!props.isMini
        }
    }

    setGame(game) {
        GameData.setCurrentGame(game.id);
        ApplicationState.addAlert('success', 'Game loaded!');
    }

    getCardHtml() {
        if (this.state.game) {
            const game = this.state.game;
            return (
                <div className="game-card">
                    <Card>
                        <Card.Body>
                            <Card.Title>{game.title}</Card.Title>
                            <Card.Text as="table">
                                <tbody>
                                    <tr>
                                        <td>Author</td>
                                        <td>{game.author}</td>
                                    </tr>
                                    <tr>
                                        <td>Updated</td>
                                        <td>{(DateTime.fromMillis(game.updated)).toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)}</td>
                                    </tr>
                                </tbody>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </div>
            );
        } else {
            return (
                <div className="game-card">
                    <Card>
                        <Card.Body>
                            <Placeholder as={Card.Title} animation="glow">
                                <Placeholder xs={6} />
                            </Placeholder>
                            <Placeholder animation="glow" xs={12} />
                            <Card.Text as="table">
                                <tbody>
                                    <tr>
                                        <td>Author</td>
                                        <Placeholder as="td" animation="glow"><Placeholder xs={12} /></Placeholder>
                                    </tr>
                                    <tr className="small">
                                        <td>Updated</td>
                                        <Placeholder as="td" animation="glow"><Placeholder xs={12} /></Placeholder>
                                    </tr>
                                </tbody>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </div>
            );
        }
    }

    getMiniHtml() {
        if (this.state.game) {
            const game = this.state.game;
            return (
                <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start game-card">
                    <Container className="">
                        <Row>
                            <Col s={6}>
                                <div className="fw-bold">{game.title}</div>

                                {game.author ? <>
                                    <div>By {game.author}</div>
                                    <div><small>{(DateTime.fromMillis(game.created)).toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)}</small></div>
                                </> : ''}
                            </Col>
                            <Col s={6} className="load-button">
                                {this.props.showOpen ? (<>
                                    {game.id !== GameData.currentGameId ? (<>
                                        <Button variant="outline-primary" className="mx-1" size="sm" onClick={() => this.setGame(game) }>Open</Button> 
                                        <Button variant="outline-info" className="mx-1" size="sm" onClick={() => this.props.doExport()}>Export</Button>
                                        <Button variant="outline-danger" size="sm" onClick={() => this.props.doDelete(game) }>Delete</Button>
                                    </>) : <> 
                                        <Button variant="outline-secondary loaded-btn" className="mx-1" size="sm" disabled>Loaded</Button> 
                                        <Button variant="outline-info" className="mx-1" size="sm" onClick={() => this.props.doExport()}>Export</Button>
                                        <Button variant="outline-danger" size="sm" onClick={() => this.props.doDelete(game) }>Delete</Button>
                                    </>}
                                </>): ''}
                            </Col>
                        </Row>
                    </Container>
                </ListGroup.Item>
            );
        } else {
            return (
                <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start game-card">
                    <div className="ms-2 me-auto">
                        <Placeholder as="div" animation="glow" className="fw-bold">
                            <Placeholder />
                        </Placeholder>
                        <Placeholder animation="glow" className="wide"><Placeholder className="wide" /></Placeholder>
                    </div>
                </ListGroup.Item>
            );
        }

    }

    render() {
        if (this.state.isMini) {
            return this.getMiniHtml();
        } else {
            return this.getCardHtml();
        }
    }
}